import { createRouter, createWebHistory } from 'vue-router';
import axios from 'axios';
import HomePage from '@/components/HomePage.vue';
import AboutUs from '@/components/AboutUs.vue';
import ContactUs from '@/components/ContactUs.vue';
import PrivacyPolicy from '@/components/PoliticaConfidentialitate.vue';
import TermsAndConditions from '@/components/TermeniConditii.vue';
import ClientLogin from '@/components/ClientLogin.vue';
import ClientSignUp from '@/components/ClientSignUp.vue';
import ClientDashboard from '@/components/ClientDashboard.vue';
import BuyTickets from '@/components/BuyTickets.vue';
import VerifyAccount from '@/components/VerifyAccount.vue';
import PublicInfo from '@/components/PublicInfo.vue';
import ManagementInfo from '@/components/ManagementInfo.vue';
import ErrorPage from "@/components/ErrorPage.vue";
import PaymentSuccess from "@/components/PaymentSuccess.vue";
import PaymentFailed from "@/components/PaymentFailed.vue";
import ForgotPassword from "@/components/ForgotPassword.vue";
import ResetPassword from "@/components/ResetPassword.vue";



const routes = [
  { path: '/', name: 'Home', component: HomePage },
  { path: '/despre-noi', name: 'AboutUs', component: AboutUs },
  { path: '/contact', name: 'Contact', component: ContactUs },
  { path: '/politica', name: 'PoliticaConfidentialitate', component: PrivacyPolicy },
  { path: '/termeni', name: 'TermeniConditii', component: TermsAndConditions },
  { path: '/informatii-publice', name: 'PublicInfo', component: PublicInfo },
  { path: '/conducere', name: 'ManagementInfo', component: ManagementInfo },
  { path: '/inregistrare', name: 'Inregistrare', component: ClientSignUp },
  { path: '/login', name: 'Autentificare', component: ClientLogin },
  { path: '/verificare-cont', name: 'VerificareCont', component: VerifyAccount },
  { path: "/forgot-password", name: "ForgotPassword", component: ForgotPassword },
  { path: "/resetare-parola", name: "ResetPassword", component: ResetPassword },
  // Rute protejate
  { 
    path: '/dashboard', 
    name: 'Dashboard', 
    component: ClientDashboard, 
    meta: { requiresAuth: true, requiresVerification: true }
  },   { 
    path: "/error/:code", 
    component: ErrorPage, 
    props: route => ({ errorCode: parseInt(route.params.code) })
  },
  { 
    path: "/:pathMatch(.*)*", 
    component: ErrorPage, 
    props: { errorCode: 404 }
  },
  { 
    path: '/bilete', 
    name: 'Bilete', 
    component: BuyTickets, 
    meta: { requiresAuth: true, requiresVerification: true }
  },  { 
    path: '/plata-validata', 
    name: 'PlataDa', 
    component: PaymentSuccess, 
    meta: { requiresAuth: true, requiresVerification: true }
  },{ 
    path: '/plata-esuata', 
    name: 'PlataNu', 
    component: PaymentFailed, 
    meta: { requiresAuth: true, requiresVerification: true }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});


// Verifică autentificarea și verificarea contului
// Verifică autentificarea și statusul verificării
router.beforeEach(async (to, from, next) => {
  try {
    const response = await axios.get('https://api.feribot-eurobac.ro/client/api/check-auth/', {
      withCredentials: true,
    });

    if (response.data.isAuthenticated) {
      if (!response.data.isVerified && to.path !== '/verificare-cont') {
        return next('/verificare-cont');
      }
      return next(); // ✅ permite navigarea normală
    }

    if (to.meta.requiresAuth) {
      return next('/login');
    }

    next();
  } catch (error) {
    console.error('Eroare la verificarea autentificării:', error);
    if (to.meta.requiresAuth) {
      return next('/login');
    }
    next();
  }
});


export default router;
